export interface DisplayCurrency {
	/** Multiplier applied to stored USD amounts: shown = usd * rate. */
	rate: number;
	/** ISO currency code, e.g. "USD" or "EUR". */
	code: string;
	/** Symbol prefixed to formatted amounts, e.g. "$" or "€". */
	symbol: string;
}

const USD: DisplayCurrency = { rate: 1, code: "USD", symbol: "$" };

// Ambient display currency, set once at app startup (mirrors `setPricingLogger`).
// Costs are stored in USD; this converts them for display so existing
// `formatCost(...)` call sites switch currency without per-site changes.
let displayCurrency: DisplayCurrency = USD;

export function setDisplayCurrency(currency: DisplayCurrency): void {
	displayCurrency = currency;
}

export function getDisplayCurrency(): DisplayCurrency {
	return displayCurrency;
}

/**
 * Format a USD cost in the active display currency with 4 decimal places.
 */
export function formatCost(cost?: number | null): string {
	const { symbol, rate } = displayCurrency;
	if (!cost || cost === 0) return `${symbol}0.0000`;
	return `${symbol}${(cost * rate).toFixed(4)}`;
}
